// @flow

import React from 'react';
import pdf from '../../../../resources/apollo_calculation_rules.pdf';

type Props = {
  label: string,
  kpiValue: any,
  isFocus: boolean,
  isPositive?: boolean,
  hideInfoBox: boolean,
  isEstimated?: boolean,
}

function RoiKpiPopinDetails({
  label, kpiValue, isFocus, isPositive, hideInfoBox, isEstimated,
}: Props) {
  const getFocusClassname = () => {
    if (isFocus) {
      return ` roi-kpi-popin-details--focus-${isPositive ? 'positive' : 'negative'}`;
    }
    return '';
  };

  const getEstimatedClassname = () => `${isEstimated ? 'roi-kpi-popin-details--estimated' : ''}`;

  return (
    <div className={`roi-kpi-popin-details${getFocusClassname()} ${getEstimatedClassname()}`}>
      {
        label && (
          <div className="roi-kpi-popin-details-label-container">
            <div className="roi-kpi-popin-details-label roi-label">{label}</div>
            {
              !hideInfoBox &&
              (<a target="_blank" href={pdf} rel="noopener noreferrer"><i className="fa fa-indo-circle" /></a>)
            }
          </div>
        )
      }
      <div className="roi-kpi-popin-details-value">{kpiValue}</div>
    </div>
  );
}

export default RoiKpiPopinDetails;
